module.exports = __webpack_public_path__ + "static/media/avatar.f15f5cba.png";